import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Why do all three bureaus show different information?',
    a: 'Bureaus receive reporting updates at different times from different furnishers. Complaint records show timing inconsistencies and incomplete synchronization are common across consumer files.'
  }, {
    q: 'I disputed an account and my score dropped. Why?',
    a: 'Disputes can temporarily affect utilization, account status visibility, or scoring inputs while investigations process. Monitoring bureau timelines matters more than reacting to short-term movement.'
  }, {
    q: 'Why is this site better than credit repair gurus on YouTube?',
    a: 'Blinkblis uses public complaint records, federal statutes, and documented reporting analysis instead of motivational claims or unverifiable success stories.'
  }, {
    q: 'If credit repair is regulated, why are so many companies operating?',
    a: 'Some companies operate legally within disclosure rules. Others attract FTC and CFPB scrutiny for misleading promises, opaque billing, or prohibited marketing claims.'
  }, {
    q: "How does Blinkblis make money if it's free to read?",
    a: 'Blinkblis earns affiliate revenue from selected financial tools while maintaining editorial independence and public-source research standards.'
  }, {
    q: 'Why were my Credit Karma scores nowhere near my mortgage pull?',
    a: 'Many free monitoring platforms display educational scoring models instead of lender-used FICO mortgage models. Bureau data timing differences also affect score calculations.'
  }, {
    q: "Doesn't monitoring just create awareness, not solutions?",
    a: 'Correct. Monitoring creates visibility. Consumers still review, document, and submit disputes independently under federal law.'
  }, {
    q: "Why do bureaus 'verify' disputed accounts so quickly?",
    a: 'CFPB complaints frequently reference concerns about reinvestigation quality and automated verification processes involving furnishers and reporting systems.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 lg:py-36 bg-offwhite relative" data-id="element-119">
      {/* Subtle dot grid background */}
      <div className="absolute inset-0 opacity-[0.015] pointer-events-none" data-id="element-120">
        <div className="absolute inset-0" style={{
        backgroundImage: 'radial-gradient(circle, #64748b 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-121"></div>
      </div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-122">
        <div className="text-center mb-12" data-id="element-123">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-navy mb-4" data-id="element-124">
            Frequently Asked Questions
          </h2>
          <p className="text-slate font-medium leading-[1.75]" data-id="element-125">
            Clear, honest answers about the reporting process.
          </p>
        </div>

        <div className="space-y-4" data-id="element-126">
          {faqs.map((faq, index) => {
          const isExpanded = openIndex === index;
          const panelId = `faq-panel-${index}`;
          const buttonId = `faq-button-${index}`;
          return <div key={index} className={`bg-white rounded-lg border transition-colors duration-200 overflow-hidden ${isExpanded ? 'border-emerald-200 bg-emerald-50/10' : 'border-slate-200'}`} data-id="element-127">
                <button id={buttonId} aria-expanded={isExpanded} aria-controls={panelId} onClick={() => setOpenIndex(isExpanded ? null : index)} className="w-full px-6 py-6 text-left flex justify-between items-center focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald/50" data-id="element-128">
                  <span className="font-bold text-navy pr-8 text-lg" data-id="element-129">
                    {faq.q}
                  </span>
                  <div className="flex-shrink-0 text-emerald-600" data-id="element-130">
                    {isExpanded ? <Minus className="w-5 h-5" aria-hidden="true" data-id="element-131" /> : <Plus className="w-5 h-5" aria-hidden="true" data-id="element-132" />}
                  </div>
                </button>
                <AnimatePresence data-id="element-133">
                  {isExpanded && <motion.div id={panelId} role="region" aria-labelledby={buttonId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: 'easeInOut'
              }} data-id="element-134">
                      <div className="px-6 pb-6 text-slate leading-[1.75] pt-2" data-id="element-135">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}